/* The Organic Butchery — Christmas 2026
   Category tabs, rail arrows, sticky offsets, feature-product sizes,
   mobile filter sheet. Loaded once, even if several sections include it. */
(function () {
  if (window.__x26) return;
  window.__x26 = true;

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  /* --- sticky offsets: sit the filter bar under the theme's sticky header --- */
  /* the main menu (tob-mega-menu) is its own sticky section under the header,
     so its height counts too; it stays put when the header slides away */
  const menuSection = () => {
    const mm = $('.tob-mm');
    const sec = mm && mm.closest('.shopify-section');
    return sec && getComputedStyle(sec).position === 'sticky' ? sec : null;
  };
  function offsets() {
    const header = $('.shopify-section-group-header-group .site-header') || $('.site-header');
    const wrap = header ? (header.closest('.shopify-section') || header) : null;
    const hidden = header && header.classList.contains('is-hidden');
    const menu = menuSection();
    /* the menu is tucked 1px under the header (tob-mega-menu.js), so its bottom is
       header + menu - 1. Floor and tuck this bar 1px under it as well: rounding
       the fractional heights up left hairline gaps between the stuck bars. */
    const hdrH = wrap && !hidden ? wrap.getBoundingClientRect().height : 0;
    const menuH = menu ? menu.getBoundingClientRect().height - (hdrH ? 1 : 0) : 0;
    const h = hdrH + menuH > 0 ? Math.max(0, Math.floor(hdrH + menuH) - 1) : 0;
    document.documentElement.style.setProperty('--x26-hdr', h + 'px');
    const tabs = $('.x26-tabs');
    document.documentElement.style.setProperty('--x26-tabs', tabs ? Math.round(tabs.getBoundingClientRect().height) + 'px' : '0px');
  }
  offsets();
  addEventListener('resize', offsets);
  addEventListener('load', offsets);
  /* the menu section turns sticky (and can change height) after its own script runs */
  const mmSection = $('.tob-mm') && $('.tob-mm').closest('.shopify-section');
  if (mmSection && 'ResizeObserver' in window) new ResizeObserver(offsets).observe(mmSection);
  if (mmSection && 'MutationObserver' in window) {
    new MutationObserver(offsets).observe(mmSection, { attributes: true, attributeFilter: ['class'] });
  }
  /* "sticky on scroll up" header mode toggles .is-hidden — keep the tabs flush with it */
  const scrollHeader = $('.site-header--scroll');
  if (scrollHeader && 'MutationObserver' in window) {
    new MutationObserver(offsets).observe(scrollHeader, { attributes: true, attributeFilter: ['class'] });
  }

  /* --- category tabs: jump to a section, never filter ---
     A tab (or a category tile) scrolls to the first section whose "Tab key"
     matches, landing just under the sticky header and the stuck tabs. The
     first tab ("all") goes to the start of the range. As the page scrolls, the
     highlighted tab follows whichever section is under the bar.
     Keys are compared trimmed and lower-case, so "Game" matches "game". */
  const norm = k => String(k || '').trim().toLowerCase();

  /* every section after the tabs, up to the last one with a tab key */
  function tabZone() {
    const tabs = $('.x26-tabs');
    const wrap = tabs && (tabs.closest('.shopify-section') || tabs);
    const sections = [];
    let last = -1;
    for (let el = wrap && wrap.nextElementSibling; el; el = el.nextElementSibling) {
      if (!el.classList.contains('shopify-section')) continue;
      sections.push(el);
      if (el.querySelector('[data-x26-key], [data-x26-everything]')) last = sections.length - 1;
    }
    return { tabs, sections: sections.slice(0, last + 1) };
  }
  const keyOf = sec => {
    const keyed = sec.querySelector('[data-x26-key]');
    return keyed ? norm(keyed.dataset.x26Key) : '';
  };

  /* the page offset that puts a section just under the header + tabs */
  function stopFor(sec, tabs) {
    offsets();
    const hdr = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--x26-hdr'), 10) || 0;
    return sec.getBoundingClientRect().top + scrollY - hdr - (tabs ? tabs.getBoundingClientRect().height : 0);
  }

  function markTab(key) {
    let current = null;
    $$('.x26-tab').forEach(b => {
      const on = (norm(b.dataset.key) || 'all') === key;
      if (on) { b.setAttribute('aria-current', 'true'); current = b; } else b.removeAttribute('aria-current');
    });
    /* keep the highlighted pill visible in a sideways-scrolling bar */
    const track = current && current.closest('.x26-tabs__track');
    if (track) {
      const t = track.getBoundingClientRect(), c = current.getBoundingClientRect();
      if (c.left < t.left || c.right > t.right) track.scrollTo({ left: track.scrollLeft + c.left - t.left - 12, behavior: smooth });
    }
  }

  let spyLock = 0;
  function goToTab(rawKey) {
    const key = norm(rawKey) || 'all';
    const { tabs, sections } = tabZone();
    const target = key === 'all' ? sections[0] : sections.find(sec => keyOf(sec) === key);
    if (!target) return;
    markTab(key);
    /* hold the highlight on the chosen tab while the page glides past others */
    spyLock = Date.now() + 1200;
    scrollTo({ top: Math.max(0, stopFor(target, tabs)), behavior: smooth });
  }

  /* scroll-spy: highlight the tab for the section currently under the bar */
  let spyQueued = false;
  function spy() {
    spyQueued = false;
    if (Date.now() < spyLock) return;
    const { tabs, sections } = tabZone();
    if (!tabs || !sections.length) return;
    const line = tabs.getBoundingClientRect().bottom + 2;
    let key = 'all';
    for (const sec of sections) {
      if (sec.getBoundingClientRect().top > line) break;
      const k = keyOf(sec);
      /* untied sections (reviews, farm story) keep the previous highlight;
         "all" rails return it to the first tab */
      if (k) key = k;
      else if (sec.querySelector('[data-x26-everything]')) key = 'all';
    }
    const active = $('.x26-tab[aria-current="true"]');
    if (!active || (norm(active.dataset.key) || 'all') !== key) markTab(key);
  }
  if ($('.x26-tabs')) {
    addEventListener('scroll', () => { if (!spyQueued) { spyQueued = true; requestAnimationFrame(spy); } }, { passive: true });
    addEventListener('scrollend', () => { spyLock = 0; spy(); });
  }

  document.addEventListener('click', e => {
    const tab = e.target.closest('.x26-tab, [data-x26-tab]');
    if (tab) {
      e.preventDefault();
      goToTab(tab.dataset.key || tab.dataset.x26Tab);
      return;
    }
    const arrow = e.target.closest('[data-x26-scroll]');
    if (arrow) {
      const track = $(arrow.dataset.x26Scroll);
      if (track) track.scrollBy({ left: Number(arrow.dataset.dir) * track.clientWidth * 0.9, behavior: smooth });
      return;
    }
    /* in-page links (hero buttons) land below the sticky header + tabs */
    const anchor = e.target.closest('.x26 a[href^="#"]');
    if (anchor && anchor.getAttribute('href').length > 1 && !anchor.dataset.key) {
      const target = $(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        offsets();
        target.scrollIntoView({ behavior: smooth, block: 'start' });
        history.replaceState(null, '', anchor.getAttribute('href'));
      }
    }
  });

  /* --- rail + carousel arrows --- */
  function syncArrows() {
    $$('[data-x26-scroll]').forEach(a => {
      const track = $(a.dataset.x26Scroll);
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      const off = max <= 0 || (Number(a.dataset.dir) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max);
      a.setAttribute('aria-disabled', off ? 'true' : 'false');
    });
  }
  document.addEventListener('scroll', e => {
    if (e.target instanceof Element && e.target.matches('.x26-rail__track, .x26-crail__track, .x26-tabs__track, .x26-quotes')) syncArrows();
  }, true);
  addEventListener('resize', syncArrows);
  requestAnimationFrame(syncArrows);

  /* --- feature product: size choice updates the price and the add-to-cart id.
     Delegated, so it keeps working after the theme editor re-renders a section. */
  document.addEventListener('change', e => {
    const input = e.target.closest('.x26-size input');
    const section = input && input.closest('[data-x26-feature]');
    if (!section) return;
    const price = $('[data-x26-price]', section);
    const idInput = $('input[name="id"]', section);
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    if (idInput && input.value) idInput.value = input.value;
    const from = $('[data-x26-from]', section);
    if (from) from.hidden = true;
  });

  /* --- collection "Load more": append the next page in place (the link still
     works as plain pagination without JS) --- */
  document.addEventListener('click', async e => {
    const more = e.target.closest('[data-x26-more]');
    if (!more || more.getAttribute('aria-busy') === 'true') return;
    const grid = $('[data-x26-grid]');
    if (!grid) return;
    e.preventDefault();
    more.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(more.href);
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const nextGrid = $('[data-x26-grid]', doc);
      if (!nextGrid) throw new Error('no grid');
      const first = nextGrid.firstElementChild;
      grid.append(...nextGrid.children);
      const nextMore = $('[data-x26-more]', doc);
      if (nextMore) { more.href = nextMore.getAttribute('href'); more.textContent = nextMore.textContent; more.removeAttribute('aria-busy'); }
      else more.remove();
      const count = $('[data-x26-count]');
      const nextCount = $('[data-x26-count]', doc);
      if (count && nextCount) count.textContent = nextCount.textContent;
      const link = first && $('a[href]:not([tabindex="-1"])', first);
      if (link) link.focus({ preventScroll: true });
    } catch (err) {
      location.assign(more.href);
    }
  });

  /* --- mobile: pin the filter tabs under the main menu, above the hero --- */
  const pinned = $('.x26-tabs--top-sm');
  if (pinned) {
    const wrapper = pinned.closest('.shopify-section') || pinned;
    const parent = wrapper.parentElement;
    const mq = matchMedia('(max-width: 860px)');
    const place = () => {
      if (!parent) return;
      if (mq.matches) {
        parent.style.display = 'flex';
        parent.style.flexDirection = 'column';
        wrapper.style.order = '-1';
      } else {
        parent.style.display = '';
        parent.style.flexDirection = '';
        wrapper.style.order = '';
      }
      offsets();
    };
    place();
    mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
  }

  /* --- arrows sit on the middle of the image band, whatever the card height --- */
  function placeArrows() {
    $$('.x26-crail, .x26-rail__wrap').forEach(rail => {
      const card = $('.x26-ccard, .x26-ugc__card, .x26-card, .pcard', rail);   /* centre on the whole card */
      if (card) rail.style.setProperty('--x26-arrow-y', Math.round(card.getBoundingClientRect().height / 2) + 'px');
    });
  }
  placeArrows();
  addEventListener('load', placeArrows);
  addEventListener('resize', placeArrows);

  /* --- creator videos: load and play only on demand --- */
  $$('[data-x26-video]').forEach(media => {
    const play = $('.x26-ugc__play', media);
    const tpl = $('[data-x26-player]', media);
    if (!play || !tpl) return;
    play.addEventListener('click', () => {
      /* stop anything already playing in this row */
      const track = media.closest('.x26-crail__track');
      if (track) $$('.is-playing', track).forEach(other => {
        if (other === media) return;
        const v = $('video', other); if (v) v.pause();
        const f = $('iframe', other); if (f) f.remove();
        other.classList.remove('is-playing');
        const p = $('[data-x26-player-live]', other); if (p) p.remove();
      });
      const node = tpl.content.cloneNode(true);
      const holder = document.createElement('div');
      holder.setAttribute('data-x26-player-live', '');
      holder.appendChild(node);
      media.appendChild(holder);
      media.classList.add('is-playing');
      const video = $('video', media);
      if (video) { video.setAttribute('playsinline', ''); video.controls = true; video.play().catch(() => {}); }
    });
  });

  /* --- urgency bar countdown --- */
  $$('[data-x26-countdown]').forEach(bar => {
    const clock = $('[data-x26-clock]', bar);
    const end = new Date(String(bar.dataset.x26Countdown).replace(' ', 'T') + ':00').getTime();
    if (!end || isNaN(end)) return;
    const pad = n => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { bar.hidden = true; clearInterval(timer); return; }
      if (clock) {
        clock.hidden = false;
        clock.querySelector('[data-d]').textContent = pad(Math.floor(left / 864e5));
        clock.querySelector('[data-h]').textContent = pad(Math.floor(left / 36e5) % 24);
        clock.querySelector('[data-m]').textContent = pad(Math.floor(left / 6e4) % 60);
      }
    };
    tick();
    const timer = setInterval(tick, 30000);
  });

  /* --- mobile filter sheet (collection page) --- */
  const sheet = $('.x26-sheet');
  if (sheet) {
    document.addEventListener('click', e => {
      if (e.target.closest('[data-x26-sheet-open]')) { sheet.classList.add('is-open'); sheet.querySelector('[data-x26-sheet-close]').focus(); }
      else if (e.target.closest('[data-x26-sheet-close]')) sheet.classList.remove('is-open');
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') sheet.classList.remove('is-open'); });
  }

  /* --- collection filters: submit on change, no Apply button needed --- */
  $$('[data-x26-facets]').forEach(form => {
    form.addEventListener('change', () => form.submit());
  });
})();
